<template>
  <div :class="$style.container">
    <button tabindex="-1" :class="$style.close" @click="modalResolve">
      <app-icon name="XIcon" size="22" :class="$style.closeIcon" />
    </button>
    <template v-if="news">
      <div
        v-if="news.image_item"
        :class="$style.image"
        :style="{backgroundImage: `url(${newsImage(news.image_item, 'res900x250')})`}"
      ></div>
      <div :class="$style.body">
        <h2 :class="$style.title">{{ news.title }}</h2>
        <div :class="$style.date">
          <app-icon name="ClockIcon" size="18px" :class="$style.dateIcon" />
          {{ formatDate(news.created_at) }}
        </div>
        <div :class="$style.content" v-if="news.text_news" v-html="news.text_news" />
      </div>
    </template>
    <div v-else :class="$style.body">
      <div class="block-loading" />
    </div>
  </div>
</template>

<script>
import modal      from "@/mixins/modalContext";
import newsImage  from "@/mixins/newsImage";
import formatDate from "@/mixins/formatDate";

export default {
  name:   "NewsPopup",
  props:  ['newsId'],
  mixins: [modal, newsImage, formatDate],
  data() {
    return {
      news: null,
    };
  },
  mounted() {
    this.$http.get(`news/${this.newsId}`).then(( { data } ) => {
      this.news = data;
    });
  },
};
</script>

<style lang="scss" module>
.container {
  position: relative;
}

.close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  border: 0;
  background: rgba(#000, .5);
  cursor: pointer;
  @include anim();

  &:hover {
    background: rgba(#000, .8);
  }

  &:active {
    background: rgba(#000, 1);
  }
}

.closeIcon {
  fill: #fff;
}

.image {
  height: 250px;
  background: #ccc 50% 50%;
  background-size: cover;
  border-radius: 3px 3px 0 0;
  @include mobile() {
    height: 160px;
  }
}

.body {
  background: #ffffff;
  padding: 3rem;
  @include mobile() {
    padding: 1rem;
  }
}

.title {
  font-size: 2.5rem;
  @include mobile() {
    font-size: 1.5rem;
  }
}

.date {
  margin-top: 1rem;
  display: flex;
  align-items: center;
}

.dateIcon {
  margin-right: .5rem;
}

.content {
  margin-top: 2rem;
  font-size: 1.5rem;
  line-height: 1.45;
  overflow-wrap: break-word;
  @include mobile() {
    margin-top: 1rem;
    font-size: 1rem;
    line-height: 1.55;
  }

  :global {
    p {
      margin-bottom: .75em;
    }

    ul, ol {
      margin-bottom: 1em;
      //line-height: 1.5;

      li {
        margin-bottom: .5em;
        position: relative;
      }
    }

    ul {
      list-style: disc;
      padding-left: 1.55em;
    }

    ol {
      counter-reset: list;
      list-style: decimal;
      padding-left: 1.55em;
    }

    del, s {
      text-decoration: line-through
    }

    img {
      max-width: 100%;
      height: auto;
      margin: .5em 0;
    }

    iframe {
      width: 100%;
      height: 300px;
    }

    .ql-align-center {
      text-align: center;
    }

    .ql-align-right {
      text-align: right;
    }

    .ql-align-justify {
      text-align: justify;
    }
  }
}

</style>
